import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TalentRealmLogo from '../../../assets/TalentRealm.svg';
import { href, useNavigate } from 'react-router-dom';

export default function Hero({ data }) {
  const navigate = useNavigate();
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 95%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 80%, 15%), transparent)',
        }),
      })}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 14, sm: 10 },
          pb: { xs: 1, sm: 20 },
        }}
      >
        <Stack
          spacing={3}
          sx={{ alignItems: 'center', width: { xs: '100%', sm: '70%' } }}
        >
          <a href="#hero" style={{ display: "flex", alignItems: "center" }}>
            <img
              src={TalentRealmLogo}
              alt="TalentRealm Logo"
              style={{}}
            />
          </a>
          <Typography
            variant="h1"
            sx={{
              fontSize: 'clamp(2.5rem, 8vw, 3.5rem)',
              textAlign: 'center',
              fontWeight: 700,
            }}
          >
            {/* {data.title} */}
            {/* <Typography
              component="span"
              variant="h1"
              sx={(theme) => ({
                display: 'block',
                fontSize: 'inherit',
                color: 'primary.main',
                ...theme.applyStyles('dark', { color: 'primary.light' }),
              })}
            > */}
              {data.subtitle}
            {/* </Typography> */}
          </Typography>

          <Typography
            sx={{
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
              fontSize: '1.1rem',
            }}
          >
            {data.summary}
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Button variant="contained" color="primary" size="large" onClick={()=>{navigate("signup")}}>
              {data.ctaText}
            </Button>
            <Button variant="outlined" color="primary" size="large" href="/#features">
              {data.secondaryCtaText}
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
